<template>
  <div class="v-stack h-stretch gap-3" v-if="$store.state.accessLevel > 9">
    <div class="h-stack h-start pb-3 gap-3">
      <router-link :to="'/lifefinance/overview' + query">Overview</router-link>
      <router-link :to="'/lifefinance/income' + query">Income</router-link>
      <router-link :to="'/lifefinance/expenses' + query">Expenses</router-link>
      <router-link :to="'/lifefinance/gear'">Gear</router-link>
      <router-link :to="'/lifefinance/crewhours' + query"
        >Crew Hours</router-link
      >
      <router-link :to="'/lifefinance/crewpay'">Crew Pay</router-link>
      <router-link :to="'/lifefinance/loans'">Company Loans</router-link>
    </div>
    <div
      class="h-stack h-start gap-3"
      v-if="
        $route.path == '/lifefinance/overview' ||
        $route.path == '/lifefinance/income' ||
        $route.path == '/lifefinance/expenses' ||
        $route.path == '/lifefinance/crewhours'
      "
    >
      <label>Period</label>

      <select v-model="period" @change="onPeriodChange()">
        <option value="all">Eternity</option>
        <option value="year">Year</option>
        <option value="month">Month</option>
        <option value="range">Range</option>
      </select>
      <template v-if="period == 'year' || period == 'month'">
        <label>Year: </label>
        <select v-model="year" @change="onPeriodChange()">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </template>
      <template v-if="period == 'month'">
        <label>Month: </label>
        <select v-model="month" @change="onPeriodChange()">
          <option v-for="i in 12" :key="i" :value="i">{{ i }}</option>
        </select>
      </template>
      <template v-if="period == 'range'">
        <label>Start: </label>
        <InputDatePicker v-model="startDate"></InputDatePicker>
        <label>End: </label>
        <InputDatePicker v-model="endDate"></InputDatePicker>
      </template>
    </div>
    <router-view
      v-if="$route.path == '/lifefinance/expenses'"
      :period="period"
      :year="year"
      :month="month"
      :startDate="startDate"
      :endDate="endDate"
    ></router-view>
    <router-view
      v-if="$route.path == '/lifefinance/crewhours'"
      :period="period"
      :year="year"
      :month="month"
      :startDate="startDate"
      :endDate="endDate"
    ></router-view>
    <router-view
      v-if="$route.path == '/lifefinance/overview'"
      :period="period"
      :year="year"
      :month="month"
      :startDate="startDate"
      :endDate="endDate"
    ></router-view>
    <router-view
      v-if="$route.path == '/lifefinance/income'"
      :period="period"
      :year="year"
      :month="month"
      :startDate="startDate"
      :endDate="endDate"
    ></router-view>
    <router-view v-if="$route.path == '/lifefinance/gear'"></router-view>
    <router-view
      v-if="
        $route.path != '/lifefinance/overview' &&
        $route.path != '/lifefinance/income' &&
        $route.path != '/lifefinance/expenses' &&
        $route.path != '/lifefinance/crewhours' &&
        $route.path != '/lifefinance/gear'
      "
    ></router-view>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import InputDatePicker from "@/components/calendar/InputDatePicker.vue";

export default {
  data() {
    return {
      period: "month",
      year: moment().year().toString(),
      month: moment().month() + 1,
      startDate: moment().date(1).toISOString(),
      endDate: moment().date(moment().daysInMonth()).toISOString(),
      years: [],
      query: "",
    };
  },
  components: {
    InputDatePicker,
  },
  watch: {
    startDate() {
      this.onPeriodChange();
    },
    endDate() {
      this.onPeriodChange();
    },
  },
  methods: {
    ...mapActions(["getYears"]),
    onPeriodChange() {
      this.query = `?period=${this.period}`;

      if (this.period == "year" || this.period == "month") {
        this.query += `&year=${this.year}`;
      }

      if (this.period == "month") {
        this.query += `&month=${this.month}`;
      }

      if (this.period == "range") {
        this.query += `&start=${this.startDate}`;
        this.query += `&end=${this.endDate}`;
      }

      if (
        this.$router.currentRoute.fullPath !=
        this.$router.currentRoute.path + this.query
      ) {
        this.$router.push(this.$router.currentRoute.path + this.query);
      }
    },
    filterDate(date) {
      const dateObject = moment(date);
      if (this.period == "year") {
        return dateObject.year() == this.year;
      } else if (this.period == "month") {
        return (
          dateObject.year() == this.year && dateObject.month() + 1 == this.month
        );
      } else if (this.period == "range") {
        return dateObject.isBetween(this.startDate, this.endDate, "day", "[]");
      } else if (this.period == "all") {
        return true;
      }
      return false;
    },
    refresh() {
      this.getYears()
        .then((years) => {
          this.years = years;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.refresh();

    if (this.$route.query.period) {
      this.period = this.$route.query.period;

      if (
        this.$route.query.period == "year" ||
        this.$route.query.period == "month"
      ) {
        this.year = this.$route.query.year.toString();
      }

      if (this.$route.query.period == "month") {
        this.month = Number(this.$route.query.month);
      }

      if (this.$route.query.period == "range") {
        this.startDate = this.$route.query.start;
        this.endDate = this.$route.query.end;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    from;

    next((vm) => {
      if (to.name) {
        if (vm.$store.state.accessLevel > 9) {
          vm.$router.push("/lifefinance/overview");
        }
      }
    });
  },
};
</script>

<style scoped>
.h-stack div {
  align-self: center;
}

.h-stack label {
  align-self: center;
}

.h-stack select {
  align-self: center;
  width: 160px;
}
</style>
